import { formatMinor, isCurrency, isMinor, minorOf } from "@nabla/api";
import type { Currency, MetricId, Money } from "@nabla/api";
import { designCopy } from "../copy.ts";


export function budget(money: Money): string {
  return formatMinor(money.minor, money.currency, { centavos: "se-houver" });
}

export function amount(money: Money): string {
  return formatMinor(money.minor, money.currency, { centavos: "nunca" });
}

export function unitCost(money: Money): string {
  return formatMinor(money.minor, money.currency, { centavos: "abaixo-de-cem" });
}

export function moneyOf(metric: MetricId): (money: Money) => string {
  if (metric === "orcamento-diario") return budget;
  return metric.startsWith("custo-por-") || metric === "cpc-link" || metric === "cpm" ? unitCost : amount;
}

export function symbolOf(currency: Currency): string {
  return formatMinor(minorOf(0), currency, { centavos: "nunca" }).replace(/[\s\u00a0]*0$/, "");
}

export function movedTo(context: Readonly<Record<string, string | number>> = {}): string | undefined {
  const [minor, currency] = [context["now"], context["currency"]];
  if (isMinor(minor) && isCurrency(currency)) return budget({ minor, currency });
  return context["now"] === "ACTIVE" || context["now"] === "PAUSED" ? designCopy.statusSemGenero[context["now"]] : undefined;
}
